/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

angular.module('prism-ui.components').service('ImageTemplatesService',
    function (this: JS5Object, _: JS5Object, ImageTemplateResourceFactory: JS5Object,
              PaginationService: JS5Object) {

        this.originalEditData = {};
        const handleGridDataQuery = (gridData, responseHeaders) => {
            PaginationService.parseResponseHeaders(responseHeaders());
            PaginationService.pageData = gridData;
            this.currentPageSize = gridData.length;
        };

        this.getAllImageTemplates = (queryParams: JS5Object) => {
            return ImageTemplateResourceFactory.query(queryParams, handleGridDataQuery).$promise;
        };
        this.getImageTemplate = (imageTemplateId: number) => {
            return ImageTemplateResourceFactory.get({id: imageTemplateId}).$promise;
        };
        this.createImageTemplate = (imageTemplate: JS5Object) => {
            return ImageTemplateResourceFactory.save(imageTemplate).$promise;
        };
        this.cloneImageTemplate = (imageTemplate: JS5Object) => {
            return ImageTemplateResourceFactory.clone({id: imageTemplate.id}).$promise;
        };
        this.updateImageTemplate = (imageTemplate: JS5Object) => {
            return ImageTemplateResourceFactory.update(imageTemplate).$promise;
        };
        this.deleteImageTemplate = (imageTemplateId: number) => {
            return ImageTemplateResourceFactory.delete({id: imageTemplateId}).$promise;
        };
    });
